import { render, staticRenderFns } from "./StorybookMenu.vue?vue&type=template&id=18e438e3"
import script from "./StorybookMenu.vue?vue&type=script&lang=js"
export * from "./StorybookMenu.vue?vue&type=script&lang=js"
import style0 from "./StorybookMenu.vue?vue&type=style&index=0&id=18e438e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports